import { render, staticRenderFns } from "./Auftragspositionen.vue?vue&type=template&id=2a4abeae&"
import script from "./Auftragspositionen.vue?vue&type=script&lang=js&"
export * from "./Auftragspositionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports